import type { CustomJsonComponentConfig } from '@apps/websiteCustomJsonComponents/config';
import { FaqAdd, FaqGrabber } from './FaqSidebar';
import { FaqEdit } from './components/FaqEdit';
import { FaqGuest } from './components/FaqGuest';

// Add this object to CUSTOM_JSON_COMPONENT_TYPES in
// src/apps/websiteCustomJsonComponents/config.ts
export const FaqConfig: CustomJsonComponentConfig = {
  schemaUrl: 'https://withjoy.com/assets/public/schemas/faqSchemaV1_0_1.json',
  componentType: 'Faq',
  adminSidebarComponent: {
    addComponentView: FaqAdd,
    dragComponentView: FaqGrabber,
    editComponentView: FaqEdit,
    createComponentView: FaqEdit,
  },
  guestSiteComponent: FaqGuest,
};
